import { Column } from 'react-table';

import { formatUnixTimestamp } from '@/shbdeployer/format';
import { Profile } from '@/core/hostmanagement/fdo/model';

export const created: Column<Profile> = {
  Header: 'Создан',
  accessor: 'dateCreated',
  id: 'created',
  Cell: ({ value }) => formatUnixTimestamp(value),
  disableFilters: true,
  canHide: true,
  Filter: () => null,
};
